import {Injectable} from '@angular/core';
import { environment as environmentMain } from 'src/environments/environment';
import { RoleEnum } from '../models/role.enum';
import { ModulTozsamosciService } from './modul-tozsamosci-service/modul-tozsamosci.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(
    private readonly mtService: ModulTozsamosciService
  ) {
  }

  listRoles(): string[] {
    return this.mtService.getParsedToken()?.payload?.resource_access[environmentMain.mt.config.clientId]?.roles || [];
  }

  hasOneOfRole(role: RoleEnum[]): boolean {
    return this.listRoles().some(rola => role.some(r => r.toString() === rola));
  }

  hasRole(rola: RoleEnum): boolean {
    return this.hasOneOfRole([rola]);
  }

  getRolesForForm(symbol: string): RoleEnum[] {
    const baseRoles = [RoleEnum.ROLE_PRS_KOMORNIK, RoleEnum.ROLE_PRS_ZUS, RoleEnum.ROLE_PRS_SYNDYK, RoleEnum.ROLE_PRS_SAD, RoleEnum.ROLE_PRS_KAS, RoleEnum.ROLE_PRS_OSOBAPRAWNA];

    if (symbol.startsWith('KW-WK') || symbol.startsWith('KRS-WP')) {
      return baseRoles;
    }

    return [...baseRoles, RoleEnum.ROLE_PRS_OSOBAFIZYCZNA];
  }

  hasAccessForForm(symbol: string): boolean {
    return this.hasOneOfRole(this.getRolesForForm(symbol));
  }

  isKierownik(): boolean {
    return this.hasOneOfRole([RoleEnum.CCI_Kierownik]);
  }

  isAppWew(): boolean {
    return this.hasOneOfRole([
      RoleEnum.CCI_Administrator,
      RoleEnum.CCI_Kierownik,
      RoleEnum.CCI_Pracownik,
      RoleEnum.CCI_Pracownik_Legislacja,
      RoleEnum.EKRS_Administrator
    ]);
  }

  hasCiRole(): boolean {
    return this.hasOneOfRole([
      RoleEnum.CCI_Administrator,
      RoleEnum.CCI_Kierownik,
      RoleEnum.CCI_Pracownik,
      RoleEnum.CCI_Pracownik_Legislacja,
    ]);
  }

  isPanelMfkAdmin(): boolean {
    return this.hasOneOfRole([
      RoleEnum.EKRS_Administrator
    ]);
  }
}
